export const theme = {
  color: {
    white: "#FFF",
    whisper: "#F5F5Fa",
    mystic: "#E4E6F0",
    silver: "#C4C4C4",
    grey: "#7E839A",
    shadow: "#BAC7D580",
    woodsmoke: "#18181B",
    black: "#000000",
    sky: "#D6E4FF",
    chetwodeBlue: "#8ba6dbff",
    blue: "#0044CCFF",
  },
  breakpoint: {
    beneathFullHD: 1440,
    desktopStandard: 1280,
    tabletLandscape: 1024,
    mobile: 768,
    smallTablet: 640,
    horizontalMobile: 576,
  },
};